import {INavData} from '@coreui/angular';
import { environment } from '../environments/environment';

// Function to get dynamic nav items based on current assessment year
export function getNavItems(currentAssessmentYear?: string): INavData[] {
  const isProduction:boolean = environment.production;
  const navItems: INavData[] = [
    {
      name: 'Home',
      url: '/user-panel/home',
      icon: 'icon-side_bar_icon_3'
    },
    {
      name: 'Submission',
      url: '/user-panel',
      icon: 'icon-side_bar_icon_4',
      children: [
        {
          name: 'Regular e-Return',
          url: '/user-panel/assessment/regular-return',
          icon: 'icon-puzzle',
          class: 'regular-return-menu'
        }
      ]
    },

    // {
    //   name: 'Report',
    //   url: '/user-panel/report',
    //   icon: 'icon-chart'
    // },

//   {
//     title: true,
//     name: 'Components'
//   },
    {
      name: 'Tax Record',
      url: '/Certificate',
      icon: 'icon-side_bar_icon_2',
      children: [
        {
          name: 'TIN Certificate',
          url: '/user-panel/tin-certificate',
          icon: 'icon-puzzle'
        },
        {
          name: 'Express Certificate/ PSR Verification Request',
          url: '/user-panel/income-tax-certificate',
          icon: 'icon-puzzle',
          class: 'side-menu-express-certificate'
        },
        {
          name: 'Certificate Status',
          url: '/user-panel/tax-certificate-request',
          icon: 'icon-puzzle'
        },
        {
          name: 'Acknowledgement',
          url: '/user-panel/ack-receipt',
          icon: 'icon-puzzle'
        },
        // {
        //   name: 'Verification Slip',
        //   url: '/user-panel/submission-slip',
        //   icon: 'icon-puzzle'
        // },
        {
          name: 'Return',
          url: '/user-panel/final-return-view',
          icon: 'icon-puzzle'
        },
        {
          name: 'Challan',
          url: '/user-panel/challan-history',
          icon: 'icon-puzzle'
        },

        // ------------------- remove history for few days. -------------------
        {
          name: 'History',
          url: '/user-panel/archive',
          icon: 'icon-puzzle'
        },

        // ------------------- remove history for few days. -------------------

      ]
    },
    // {
    //   name: 'Time Extension',
    //   url: '/user-panel/time-extension',
    //   icon: 'icon-side_bar_icon_1'
    // },
  ];

  // Add amendment return menu item only if current assessment year is 2024-25
  // if (currentAssessmentYear === '2024-2025') {
  // if(!isProduction || currentAssessmentYear !== '2026-2027') {
  //   navItems[1].children.push({
  //     name: 'Revised Return U/S-180(2)',
  //     url: '/user-panel/amendment-return',
  //     icon: 'icon-puzzle',
  //     class: 'amendment-return-menu'
  //   });
  // }
  // // }

  navItems[1]?.children?.push({
    name: 'Revised Return U/S-180(2)',
    url: '/user-panel/amendment-return',
    icon: 'icon-puzzle',
    class: 'amendment-return-menu'
  });
  if (currentAssessmentYear === '2025-2026') {
    navItems.splice(2, 0, {
      name: 'Time Extension',
      url: '/user-panel/time-extension',
      icon: 'icon-side_bar_icon_1',
      class: 'regular-return-menu'
    });
  }

  if (!isProduction) {
    navItems.push({
      name: 'Audited Accounts',
      url: '/user-panel/audited-accounts',
      icon: 'icon-side_bar_icon_3',
    });
  }
  return navItems;
}

// Default export for backward compatibility
export const navItems: INavData[] = getNavItems();
